import EmersonIcon from "@emerson/assets/icons/emerson-leaf.png";

interface Props {
  isEmerson?: boolean;
}

const EmersonFavicon = ({ isEmerson = true }: Props) => {
  if (!isEmerson) return null;

  return <link rel="icon" href={EmersonIcon} type="image/png" sizes="any" />;
};

export { EmersonFavicon };
